import { components } from "../../../common/namespace";

declare global {
  interface OttoComponents {
    /** kaka */
    bannerV1: BannerV1Api;
  }
}

export interface BannerV1Api {
  list(): HTMLOcBannerV1Element[];
}

function getListFunction<T extends keyof HTMLElementTagNameMap>(
  tag: T
): () => HTMLElementTagNameMap[T][] {
  return () => Array.from(document.querySelectorAll(tag));
}

components.bannerV1 = {
  list: getListFunction("oc-banner-v1"),
};
